import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getClientFeatures } from "src/apis/ClientAPI";
// Import your API function

// Define initial state
export interface FeaturesState {
  features: string[]; // Assuming features are returned as an array of feature names
  loading: boolean;
  error: string | null;
}

const initialState: FeaturesState = {
  features: [],
  loading: false,
  error: null,
};

// Async thunk to fetch features
export const fetchClientFeatures = createAsyncThunk(
  "features/fetchClientFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getClientFeatures();
      if (response.status !== 200) {
        return rejectWithValue(response.data);
      }
      return response.data; // Assuming response.data contains an array of feature names
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const featuresSlice = createSlice({
  name: "features",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.features = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchClientFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const selectHasFeature = (state: any, featureName: number) => {
  return state.features.features.includes(featureName);
};

export default featuresSlice.reducer;
